import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * /platform is a container — redirect to the default child (/platform/users)
 * so the outer sidebar's "Platform Administration" entry always lands on the
 * Users page, matching the inner platform sidebar's default order.
 */
export const Route = createFileRoute('/_authenticated/_tenant/platform/')({
  beforeLoad: ({ search }) => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error -- TanStack Router requires throwing a redirect
    throw redirect({ to: '/platform/users', search });
  },
});
